import React from 'react';

const UnderlineTestPage: React.FC = () => {
  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold">Underline Test Page</h1>
      <p className="mt-4 text-gray-600">This is a placeholder for the underline test page.</p>
    </div>
  );
};

export default UnderlineTestPage;
